import { render, staticRenderFns } from "./ManageProductType.vue?vue&type=template&id=0ad93ba2"
import script from "./ManageProductType.vue?vue&type=script&lang=js"
export * from "./ManageProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports